import React from 'react';
import { Helmet } from 'react-helmet';

import Card from '@components/Card';
import SignOut from '@shared/SignOut';

import OverrideFiles from '../Console/Main/OverrideFiles';
import Section from './components/Section';
import PersonalInfo from './PersonalInfo';

export default function UserProfile() {
  return (
    <>
      <Helmet>
        <title>User Profile &middot; Enigma Screen UI</title>
      </Helmet>
      <Card title='User Profile' shadow>
        <PersonalInfo />
        <Section>
          <SignOut />
        </Section>
      </Card>
      <Card title='Override rules file' shadow>
        <OverrideFiles />
      </Card>
    </>
  );
}
